import React from "react";

/* ── Super Admin: Task Visibility Rules Panel ─────────── */
export default function SATaskVisibilityPanel({platform,dispatch}){
  const rules=platform.taskVisibilityRules||{};
  const ROLES=["owner","manager","family","driver","maid","staff","supervisor"];
  const VIEW_OPTIONS=[
    {value:"all",label:"All Tasks"},
    {value:"all_except_owner_private",label:"All Except Owner-Private"},
    {value:"assigned_only",label:"Assigned To Them Only"},
    {value:"assigned_and_created",label:"Assigned + Created By Them"},
    {value:"none",label:"No Access"},
  ];
  const EDIT_OPTIONS=[
    {value:"all",label:"All Tasks"},
    {value:"assigned_and_created",label:"Assigned + Created By Them"},
    {value:"assigned_only",label:"Assigned To Them Only"},
    {value:"own_only",label:"Created By Them Only"},
    {value:"none",label:"No Edit Access"},
  ];
  const LOC_OPTIONS=[
    {value:"all",label:"All Locations"},
    {value:"own_location",label:"Own Location Only"},
    {value:"none",label:"No Access"},
  ];
  const thS={padding:"8px 10px",color:"var(--cg400)",fontWeight:600,fontSize:11,textTransform:"uppercase"};
  return(
    <div style={{maxWidth:960}}>
      <div className="p-section-hd">Task Visibility & Authority</div>
      <div style={{fontSize:13,color:"var(--cg400)",marginBottom:16}}>Define which roles can view and edit tasks. These are platform-wide defaults — individual workspaces can override these in their Settings page.</div>
      <div className="p-card">
        <table style={{width:"100%",fontSize:13,borderCollapse:"collapse"}}>
          <thead><tr style={{borderBottom:"1px solid var(--cg200)",textAlign:"left"}}>
            <th style={{...thS,width:110}}>Role</th>
            <th style={thS}>View Access</th>
            <th style={thS}>Edit Access</th>
            <th style={thS}>Location (View)</th>
            <th style={thS}>Location (Edit)</th>
            <th style={thS}>Description</th>
          </tr></thead>
          <tbody>
            {ROLES.map(role=>{
              const rule=rules[role]||{view:"assigned_only",edit:"assigned_only",locationView:"all",locationEdit:"all",description:""};
              const isOwner=role==="owner";
              const locked=<span style={{fontSize:12,color:"var(--cg500)"}}>All (locked)</span>;
              return(
                <tr key={role} style={{borderBottom:"1px solid var(--cg100)"}}>
                  <td style={{padding:"10px",fontWeight:600,color:"var(--cink)",textTransform:"capitalize"}}>{role==="family"?"Family Member":role}</td>
                  <td style={{padding:"10px"}}>
                    {isOwner?locked:
                    <select className="p-input" style={{width:"100%",fontSize:12}} value={rule.view} onChange={e=>dispatch({type:"SET_TASK_VISIBILITY_RULES",role,patch:{view:e.target.value}})}>
                      {VIEW_OPTIONS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>}
                  </td>
                  <td style={{padding:"10px"}}>
                    {isOwner?locked:
                    <select className="p-input" style={{width:"100%",fontSize:12}} value={rule.edit} onChange={e=>dispatch({type:"SET_TASK_VISIBILITY_RULES",role,patch:{edit:e.target.value}})}>
                      {EDIT_OPTIONS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>}
                  </td>
                  <td style={{padding:"10px"}}>
                    {isOwner?locked:
                    <select className="p-input" style={{width:"100%",fontSize:12}} value={rule.locationView||"all"} onChange={e=>dispatch({type:"SET_TASK_VISIBILITY_RULES",role,patch:{locationView:e.target.value}})}>
                      {LOC_OPTIONS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>}
                  </td>
                  <td style={{padding:"10px"}}>
                    {isOwner?locked:
                    <select className="p-input" style={{width:"100%",fontSize:12}} value={rule.locationEdit||"all"} onChange={e=>dispatch({type:"SET_TASK_VISIBILITY_RULES",role,patch:{locationEdit:e.target.value}})}>
                      {LOC_OPTIONS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>}
                  </td>
                  <td style={{padding:"10px"}}>
                    <input className="p-input" style={{width:"100%",fontSize:12}} value={rule.description||""} onChange={e=>dispatch({type:"SET_TASK_VISIBILITY_RULES",role,patch:{description:e.target.value}})} placeholder="Description..."/>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{marginTop:12,fontSize:12,color:"var(--cg400)",lineHeight:1.6}}>
        <strong>View / Edit Access:</strong> Controls which tasks a role can see or modify based on assignment and ownership.<br/>
        <strong>Location (View / Edit):</strong> An independent filter — restricts tasks to the user's assigned location(s). Applied on top of view/edit access.<br/>
        <br/>
        • <strong>All Locations</strong> — no location restriction<br/>
        • <strong>Own Location Only</strong> — only tasks in their assigned or allowed locations<br/>
        • <strong>No Access</strong> — blocked regardless of other rules
      </div>
    </div>
  );
}
